import NaptimeResource from './NaptimeResource';

class ProgramEnrollmentsV2 extends NaptimeResource {
  static RESOURCE_NAME = 'programEnrollments.v2';
}

export default ProgramEnrollmentsV2;
